import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import boxer150 from "../../images/boxer2.jpg";
import "../../../src/product.css";

const Boxer150 = () => {
  return (
    <>
      <Header />

      <main className="product-page container text-center">
        {/* Product Hero */}

        <h2 id="title">BOXER 150cc</h2>

        <section className="product-hero">

          <div className="product-image-wrapper">
            <img
              src={boxer150}
              alt="Bajaj Boxer 150cc"
              className="product-image"
            />
          </div>

          <div className="product-info">

            <p>
              Boxer 150 is a great combination of power and fuel efficiency
              that makes it an ideal bike for city travel as well as for
              longer rides and across terrain. It is a motorcycle that
              delivers power on all load and speed conditions.
            </p>

          </div>
        </section>

        {/* Specifications */}
        <section className="product-specifications">

          <div className="section-heading">
            <span>TECHNICAL DETAILS</span>
            <h2>Specifications</h2>
          </div>

          <div className="spec-grid">

            <div className="spec-card">
              <span>Engine Type</span>
              <strong>4 Stroke Engine</strong>
            </div>

            <div className="spec-card">
              <span>Cubic Capacity</span>
              <strong>144.82 cc</strong>
            </div>

            <div className="spec-card">
              <span>Transmission</span>
              <strong>Manual</strong>
            </div>

            <div className="spec-card">
              <span>Fuel Type</span>
              <strong>Petrol</strong>
            </div>

            <div className="spec-card">
              <span>Battery</span>
              <strong>12V</strong>
            </div>

            <div className="spec-card">
              <span>Weight</span>
              <strong>123 kg</strong>
            </div>

          </div>
        </section>

      </main>

      <Footer />
    </>
  );
};

export default Boxer150;